import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  handleName: "",
  handleEmail: "",
};

export const handleLogin = createSlice({
  name: "handleLogin",
  initialState: INIT_STATE,
  reducers: {
    addItemToHandleName: (state, action) => {
      state.handleName = action.payload;
    },
    addItemToHandleEmail: (state, action) => {
      state.handleEmail = action.payload;
    },
  },
});

export const { addItemToHandleName, addItemToHandleEmail } =
  handleLogin.actions;

export default handleLogin.reducer;
